import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { SalesConfig } from '@/modules/ta/clientgroup/models/SalesConfig';

export class ClientGroup extends BaseEntityModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {?string}
   */
  cluster_id;

  /**
   * @var {?string}
   */
  cluster_name;

  /**
   * @var {string}
   */
  group_type;

  /**
   * @var {string}
   */
  group_type_display;

  /**
   * @var {boolean}
   */
  has_light_logo;

  /**
   * @var {boolean}
   */
  has_dark_logo;

  /**
   * @var {?string}
   */
  crm_id;

  /**
   * @var {datetime}
   */
  created_at;

  /**
   * @var {datetime}
   */
  formatted_created_at;

  /**
   * @var {datetime}
   */
  updated_at;

  /**
   * @var {datetime}
   */
  formatted_updated_at;

  /**
   * @var {?string}
   */
  report_language;

  /**
   * @var {string}
   */
  report_language_display;

  /**
   * @var {string}
   */
  client_ids;

  /**
   * @var {string}
   */
  client_group_ids;

  /**
   * @var {string}
   */
  timegroup;

  /**
   * @var {number}
   */
  total_clients;

  /**
   * @var {boolean}
   */
  ai_prompt_strict_professional;

  /**
   * @var {boolean}
   */
  ai_prompt_use_industry_terms;

  /**
   * @var {boolean}
   */
  ai_prompt_limit_responses;

  /**
   * @var {?string}
   */
  ai_prompt_custom_format;

  /**
   * @var {?string}
   */
  ai_prompt_additional_context;

  /**
   * @var {Object}
   */
  sales_config;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.name = model.name;
    this.cluster_id = model.cluster_id;
    this.cluster_name = model.cluster_name;
    this.group_type = model.group_type;
    this.group_type_display = model.group_type_display;
    this.has_light_logo = model.has_light_logo;
    this.has_dark_logo = model.has_dark_logo;
    this.crm_id = model.crm_id;
    this.created_at = model.created_at;
    this.formatted_created_at = model.formatted_created_at;
    this.updated_at = model.updated_at;
    this.formatted_updated_at = model.formatted_updated_at;
    this.report_language = model.report_language;
    this.report_language_display = model.report_language_display;
    this.client_ids = model.client_ids && model.client_ids.map((id) => id.toString());
    this.client_group_ids =
      model.client_group_ids && model.client_group_ids.map((id) => id.toString());
    this.timegroup = model.timegroup;
    this.total_clients = model.total_clients;
    this.ai_prompt_strict_professional = model.ai_prompt_strict_professional;
    this.ai_prompt_use_industry_terms = model.ai_prompt_use_industry_terms;
    this.ai_prompt_limit_responses = model.ai_prompt_limit_responses;
    this.ai_prompt_custom_format = model.ai_prompt_custom_format;
    this.ai_prompt_additional_context = model.ai_prompt_additional_context;
    this.sales_config = new SalesConfig(model.sales_config);

    if (this.ai_prompt_custom_format && !this.ai_prompt_limit_responses) {
      this.ai_prompt_limit_responses = true;
    }
  }
}
